import React, { Fragment } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  withStyles,
  // Button,
  MenuItem,
} from '@material-ui/core';
import {
  // Menu as MenuIcon,
  // MailOutline as MailIcon,
  // Person as AccountIcon,
  // ArrowBack as ArrowBackIcon,
  ArrowDropDown as ArrowDropDownIcon,
  // HowToReg
} from '@material-ui/icons';

import { observer, inject } from 'mobx-react';
import moment from 'moment';
import { fade } from '@material-ui/core/styles/colorManipulator';
import classNames from 'classnames';
import { Badge, Typography } from '../Wrappers';
import logo from '../../images/Presense/Logo/presense.png';
import logoWhite from '../../images/Presense/Logo/presense-white.png';
import { withTranslation } from 'react-i18next';
import config from '../../config';
import './style.css';

import ChangePassword from '../Dialog/ChangePasswordView';
import { languages } from '../../utils/common';
import { checkByRole } from '../../utils/handleSidebar';
import { tenantInfo } from '../../utils/tenantInformation';

export class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        tenantId: 0,
        tenantName: '',
      },
      language: null,
      show: false,
      messages: [],
      dialogChangePasswordOpen: false,
      seeFunc: {
        seeTenant: false,
        seeLanguage: false,
        seeLanguageTH: false,
        seeLanguageEN: false,
        seeMail: false,
        seeProfile: false,
        seeFullScreen: false,
      },
      isOpenLanguage: null,
      isOpenTenant: null,
    };
    this.fullScreenElement = null;
    this.fscreen = document;
    this.detectFullScreen = this.detectFullScreen.bind(this);
  }

  async componentDidMount() {
    this.initTenant();
    this.fscreen.addEventListener('fullscreenchange', this.detectFullScreen);
    const languageData = languages.find((l) => l.value === localStorage.getItem('i18nextLng'));
    if (languageData) {
      this.setState({
        language: languageData.label,
      });
    }
    this.handleViewPage();

    await this.props.acknowledge.getAcknowledge();
  }

  componentWillReceiveProps() {
    this.initTenant();
  }

  initTenant() {
    const tenants = tenantInfo();
    if (localStorage.getItem('select_tenant')) {
      const tenantId = localStorage.getItem('select_tenant');
      const tenantData = tenants.find((t) => t.id === +tenantId);
      if (tenantData) {
        this.setState({ data: { tenantId: tenantData.id, tenantName: tenantData.name } });
      }
    } else {
      if (tenants && tenants.length === 1) {
        tenants.forEach((t) => {
          localStorage.setItem('select_tenant', t.id);
          this.setState({ data: { tenantId: t.id, tenantName: t.name } });
        });
      } else {
        this.setState({ data: { tenantId: '', tenantName: '' } });
      }
    }
  }

  handleViewPage() {
    if (localStorage.getItem('role') === 'Technician') {
      this.setState({
        seeFunc: {
          seeLanguage: true,
          seeLanguageTH: true,
          seeLanguageEN: true,
          seeMail: false,
          seeProfile: true,
          seeFullScreen: true,
        },
      });
    } else {
      this.setState({
        seeFunc: {
          seeLanguage: true,
          seeLanguageTH: true,
          seeLanguageEN: true,
          seeMail: true,
          seeProfile: true,
          seeFullScreen: true,
        },
      });
    }
  }

  toggleHover() {
    this.setState({ show: !this.state.show });
  }

  detectFullScreen() {
    const isInFullScreen =
      (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null);

    this.props.screen.setFullScreen(isInFullScreen ? true : false);
  }

  toggleFullScreen = () => {
    const isInFullScreen =
      (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null);

    if (!isInFullScreen) {
      this.enterFullScreen();
    } else {
      this.leaveFullScreen();
    }
  };

  enterFullScreen = () => {
    const docElm = document.documentElement;
    if (docElm.requestFullscreen) {
      docElm.requestFullscreen();
    } else if (docElm.mozRequestFullScreen) {
      docElm.mozRequestFullScreen();
    } else if (docElm.webkitRequestFullScreen) {
      docElm.webkitRequestFullScreen();
    } else if (docElm.msRequestFullscreen) {
      docElm.msRequestFullscreen();
    }
  };

  leaveFullScreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  };

  handleLanguage = (event) => {
    this.setState({ isOpenLanguage: event.currentTarget });
  };

  handleOpenTenant = async (event) => {
    this.setState({ isOpenTenant: event.currentTarget });
  };

  handleChangeTenant = async (data) => {
    this.setState({ data: { tenantId: data.id, tenantName: data.name }, isOpenTenant: null });
    localStorage.setItem('select_tenant', data.id);

    // Next, we dispatch the event.
    const event = new Event('TenantChanged');
    document.dispatchEvent(event);
  };

  handleCloseLanguage = () => {
    this.setState({
      isOpenLanguage: null,
      isOpenTenant: null,
    });
  };

  changeLanguage = (data) => {
    const { i18n } = this.props;
    i18n.changeLanguage(data.value);
    this.setState({
      language: data.label,
      isOpenLanguage: null,
    });
  };

  openMailBox(event) {
    this.props.acknowledge.setRead();
    let { props } = this;
    props.openMailMenu(event);
  }

  handleOpenDialog = () => {
    this.setState({
      dialogChangePasswordOpen: true,
    });
  };

  handleClose = () => {
    const { props } = this;
    props.closeProfileMenu();
    this.setState({
      dialogChangePasswordOpen: false,
    });
  };

  getAlert = (notification) => {
    const { t } = this.props;
    let alertText = '';
    if (notification.length > 0) {
      notification.forEach((notif) => {
        if (notif.alerts && notif.alerts.length > 0) {
          notif.alerts = notif.alerts.filter((a) => a.alertType !== 513);
          notif.alerts.forEach((a) => {
            let result = `${a.alertType}`;
            switch (a.alertType) {
              case 1:
                result = `${t('lying')}`;
                break;
              case 2:
                result = `${t('sitting')}`;
                break;
              case 3:
                result = `${t('standing')}`;
                break;
              case 4:
                result = `${t('walking')}`;
                break;
              case 5:
                result = `${t('Running')}`;
                break;
              case 6:
                result = `${t('Jumping')}`;
                break;
              case 7:
                result = `${t('lying_on_back')}`;
                break;
              case 8:
                result = `${t('lying_on_stomach')}`;
                break;
              case 9:
                result = `${t('lying_on_left_side')}`;
                break;
              case 10:
                result = `${t('lying_on_right_side')}`;
                break;
              case 501:
                result = `${t('get_up')}`;
                break;
              case 502:
                result = `${t('movement')}`;
                break;
              case 503:
                result = `${t('low_battery')}`;
                break;
              case 504:
                result = `${t('alert_last_seen')}`;
                break;
              case 505:
                result = `${t('alert_router_no_signal')}`;
                break;
              case 506:
                result = `${t('alert_not_turn')}`;
                break;
              case 507:
                result = `${t('alert_no_movement')}`;
                break;
              case 508:
                result = `${t('alert_fall')}`;
                break;
              case 509:
                result = `${t('alert_exit')}`;
                break;
              case 510:
                result = `${t('alert_near')}`;
                break;
              case 511:
                result = `${t('alert_walking')}`;
                break;
              case 512:
                result = `${t('alert_deactivate_recharge')}`;
                break;
              case 513:
                result = `${t('alert_bad_signal')}`;
                break;
              case 514:
                result = `${t('alert_emergency_alarm')}`;
                break;
              default:
                break;
            }
            alertText = alertText.length > 0 ? `${alertText}, ${result}` : result;
          });
        }
      });
    }
    // console.log('alertText', alertText)
    return alertText ? `[${alertText}]` : '';
  };

  getAlertFixedEmergencyPlace = (notification) => {
    let place = '';
    if (notification.length > 0) {
      notification.forEach((notif) => {
        if (notif.alerts && notif.alerts.length > 0) {
          notif.alerts.forEach((a) => {
            place = a.alertFixedEmergencyPlace;
          });
        }
      });
    }
    return place;
  };

  getFullname = (patient) => {
    let fullname = '';

    if (localStorage.getItem('i18nextLng') === 'th-TH') {
      fullname = `${patient.firstname ?? ''} ${patient.lastname ?? ''}`;
    }
    if (localStorage.getItem('i18nextLng') === 'en-EN') {
      let firstname = patient.firstnameEn ? patient.firstnameEn : patient.firstname;
      let lastname = patient.lastnameEn ? patient.lastnameEn : patient.lastname;
      fullname = `${firstname ?? ''} ${lastname ?? ''}`;
    }
    return fullname;
  };

  getHeaderTitle = (host) => {
    let result = config.headerView.default;
    if (host.includes('banbangkhae')) {
      result = config.headerView.banbangkhae;
    } else if (host.includes('chula')) {
      result = config.headerView.chula;
    } else if (host.includes('dip')) {
      result = config.headerView.dip;
    } else if (host.includes('bangpra')) {
      result = config.headerView.bangpra;
    } else if (host.includes('phyathai')) {
      result = config.headerView.phyathai;
    } else if (host.includes('dop')) {
      result = config.headerView.dop;
    }
    return result;
  };

  signOut = async () => {
    if (config.firebase.status && localStorage.getItem('fcm_token')) {
      if (localStorage.getItem('select_module')) {
        const selectModule = JSON.parse(localStorage.getItem('select_module'));
        for (const val of selectModule || []) {
          console.log(`unSubscribeFCM Topic : ${val}_module_alert`);
          await this.props.fcm.unSubscribeFCM(localStorage.getItem('fcm_token'), `${val}_module_alert`);
          await this.props.fcm.unSubscribeFCM(localStorage.getItem('fcm_token'), `${val}_module_acknowledge`);
        }
      }
    }
    this.props.signOut();
  };

  render() {
    let { classes, isSidebarOpened, toggleSidebar, t } = this.props;
    const { seeFunc } = this.state;
    let { props } = this;
    const { activeFullScreen } = this.props.screen.toJS();
    let styleFullScreen = activeFullScreen ? { display: 'none' } : { display: isSidebarOpened ? 'none' : 'block' };
    let { data } = this.props.acknowledge.toJS();
    const host = window.location.host;
    const displayedMenus = checkByRole(localStorage.getItem('role'));

    let tenants = tenantInfo();
    // sort tenants
    tenants && tenants.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));

    // display tenant
    let seeTenant = seeFunc.seeTenant;
    seeTenant = window.location.pathname.includes('dashboard');

    return (
      <Fragment>
        {displayedMenus.length > 0 && (
          <div
            // className={isSidebarOpened ? classes.iconBack : classes.iconOpen}
            className={classes.iconOpen}
            style={styleFullScreen}
            onClick={toggleSidebar}
          >
            <svg width='26' height='26' viewBox='0 0 26 26'>
              <use xlinkHref={`/images/header.svg#expandmenus`} />
            </svg>
          </div>
        )}
        <AppBar
          // style={styleFullScreen}
          position='fixed'
          className={classes.appBar}
        >
          <Toolbar className={displayedMenus.length > 0 && !activeFullScreen ? classes.toolbarAdmin : classes.toolbar}>
            {/* {localStorage.getItem("role_id") === "1" && (
              <IconButton
                color="inherit"
                onClick={toggleSidebar}
                className={classNames(
                  classes.headerMenuButton,
                  classes.headerMenuButtonCollapse
                )}
              >
                {isSidebarOpened ? (
                  <ArrowBackIcon
                    classes={{
                      root: classNames(
                        classes.headerIcon,
                        classes.headerIconCollapse
                      ),
                    }}
                  />
                ) : (
                  <MenuIcon
                    classes={{
                      root: classNames(
                        classes.headerIcon,
                        classes.headerIconCollapse
                      ),
                    }}
                  />
                )}
              </IconButton>
            )} */}
            {host.includes('dev') || host.includes('localhost') ? (
              <img src={logo} alt='logo' width='120' />
            ) : (
              <div className={classes.iconLogo}>
                <img src={logoWhite} alt='logo' width='36' />
                {this.getHeaderTitle(host)}
              </div>
            )}
            <div className={classes.grow} />
            {seeTenant && (
              <div className={classes.languageHeader} onClick={this.handleOpenTenant}>
                <Typography weight='medium' color='primary'>
                  {this.state.data.tenantId ? this.state.data.tenantName : t('select_tenant')}
                </Typography>
                <IconButton className={classes.languageButton}>
                  <ArrowDropDownIcon classes={{ root: classes.headerIcon }} />
                </IconButton>
              </div>
            )}
            <Menu
              id='tenant-menu'
              open={Boolean(this.state.isOpenTenant)}
              anchorEl={this.state.isOpenTenant}
              onClose={this.handleCloseLanguage}
              style={{ maxHeight: 300 }}
            >
              {tenants &&
                tenants.map((data, index) => (
                  <MenuItem
                    key={index}
                    selected={this.state.data.tenantId === data.id}
                    onClick={() => this.handleChangeTenant(data)}
                  >
                    <Typography size='md' color='primary'>
                      {data.name}
                    </Typography>
                  </MenuItem>
                ))}
            </Menu>

            {seeFunc.seeLanguage && (
              <div className={classes.languageHeader} onClick={this.handleLanguage}>
                <Typography weight='medium' color='primary'>
                  {this.state.language}
                </Typography>
                <IconButton className={classes.languageButton}>
                  <ArrowDropDownIcon classes={{ root: classes.headerIcon }} />
                </IconButton>
              </div>
            )}
            <Menu
              id='language-menu'
              open={Boolean(this.state.isOpenLanguage)}
              anchorEl={this.state.isOpenLanguage}
              onClose={this.handleCloseLanguage}
            >
              {languages.map((data, index) => (
                <MenuItem
                  key={index}
                  selected={localStorage.getItem('i18nextLng') === data.value}
                  onClick={() => this.changeLanguage(data)}
                >
                  <Typography size='md' color='primary'>
                    {data.label}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
            {/* {seeFunc.seeLanguageTH && (
              <Button
                className={
                  localStorage.getItem("i18nextLng") === "th-TH"
                    ? classes.langButtonActive
                    : classes.langButton
                }
                onClick={() => this.changeLanguage("th-TH")}
              >
                th
              </Button>
            )} */}
            {/* {seeFunc.seeLanguageEN && (
              <Button
                className={
                  localStorage.getItem("i18nextLng") === "en-EN"
                    ? classes.langButtonActive
                    : classes.langButton
                }
                onClick={() => this.changeLanguage("en-EN")}
              >
                en
              </Button>
            )} */}

            {seeFunc.seeMail && (
              <IconButton
                color='inherit'
                aria-haspopup='true'
                aria-controls='mail-menu'
                onClick={(e) => this.openMailBox(e)}
                className={classes.headerMenuButton}
              >
                <Badge
                  badgeContent={props.isMailsUnread ? data.filter((val) => val.unRead).length : null}
                  color='secondary'
                >
                  <svg width='22' height='19' viewBox='0 0 22 19'>
                    <use xlinkHref={`/images/header.svg#inbox`} />
                  </svg>
                </Badge>
              </IconButton>
            )}

            <Menu
              id='mail-menu'
              open={data.length > 0 && Boolean(props.mailMenu)}
              anchorEl={props.mailMenu}
              onClose={props.closeMailMenu}
              MenuListProps={{ className: classes.headerMenuList }}
              className={classes.headerMenu}
              classes={{ paper: classes.profileMenu }}
              disableAutoFocusItem
            >
              {data.map((message, index) => (
                <MenuItem key={index} className={classes.messageNotification}>
                  <div className={classes.messageNotificationSide} style={{ width: '80px' }}>
                    <Typography size='sm' color='textSecondary'>
                      {moment(message.createdDate).format('DD/MM/YY HH:mm')}
                    </Typography>
                  </div>
                  <div className={classNames(classes.messageNotificationSide, classes.messageNotificationBodySide)}>
                    <Typography weight='medium' gutterBottom>
                      <span style={{ color: '#009D9A' }}>
                        {message.patient
                          ? this.getFullname(message.patient)
                          : `@ ${this.getAlertFixedEmergencyPlace(message.notification)}`}{' '}
                        {this.getAlert(message.notification)}{' '}
                      </span>{' '}
                      ( {t('by')} {message.user.userName} )
                    </Typography>
                  </div>
                </MenuItem>
              ))}
            </Menu>

            {seeFunc.seeProfile && (
              <IconButton
                aria-haspopup='true'
                color='inherit'
                className={classes.headerMenuButton}
                aria-controls='profile-menu'
                onClick={props.openProfileMenu}
              >
                <svg width='20' height='23' viewBox='0 0 20 23'>
                  <use xlinkHref={`/images/header.svg#account`} />
                </svg>
              </IconButton>
            )}

            {seeFunc.seeFullScreen && (
              <IconButton
                id='fullscreen-div'
                aria-haspopup='true'
                color='inherit'
                className={classes.headerMenuButton}
                aria-controls='FullScreen'
                onClick={() => this.toggleFullScreen()}
              >
                <svg width='23' height='23' viewBox='0 0 24 24'>
                  <use xlinkHref={`/images/header.svg#fullscreen`} />
                </svg>
              </IconButton>
            )}

            <Menu
              id='profile-menu'
              open={Boolean(props.profileMenu)}
              anchorEl={props.profileMenu}
              onClose={props.closeProfileMenu}
              className={classes.headerMenu}
              classes={{ paper: classes.profileMenu }}
              disableAutoFocusItem
            >
              <div className={classes.profileMenuUser}>
                <Typography variant='h4' weight='medium'>
                  {localStorage.getItem('user') || null}
                </Typography>
              </div>
              <hr className={classes.dialogMenu} />
              <div className={classes.profileMenulist}>
                <Typography className={classes.profileMenuLink} color='primary' onClick={this.handleOpenDialog}>
                  {t('changePassword')}
                </Typography>
              </div>
              <div className={classes.profileMenulist}>
                <Typography className={classes.profileMenuLink} color='primary' onClick={this.signOut}>
                  {t('sign_out')}
                </Typography>
              </div>
            </Menu>
          </Toolbar>
        </AppBar>
        {this.state.dialogChangePasswordOpen && (
          <ChangePassword props={this.props} state={this.state} handleClose={this.handleClose} />
        )}
      </Fragment>
    );
  }
}

const styles = (theme) => ({
  logotype: {
    color: 'white',
    marginLeft: theme.spacing.unit * 2.5,
    marginRight: theme.spacing.unit * 2.5,
    fontWeight: 500,
    fontSize: 18,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  appBar: {
    width: '100vw',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    background: theme.palette.primary.gradient,
    boxShadow: 'none',
  },
  toolbarAdmin: {
    padding: 0,
    marginLeft: theme.spacing.unit * 10,
    marginRight: theme.spacing.unit * 2,
    minHeight: 54,
  },
  toolbar: {
    padding: 0,
    marginLeft: theme.spacing.unit * 4,
    marginRight: theme.spacing.unit * 2,
    minHeight: 54,
  },
  hide: {
    display: 'none',
  },
  grow: {
    flexGrow: 1,
  },
  search: {
    position: 'relative',
    borderRadius: 25,
    paddingLeft: theme.spacing.unit * 2.5,
    width: 36,
    backgroundColor: fade(theme.palette.common.black, 0),
    transition: theme.transitions.create(['background-color', 'width']),
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: fade(theme.palette.common.black, 0.08),
    },
  },
  searchFocused: {
    backgroundColor: fade(theme.palette.common.black, 0.08),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 250,
    },
  },
  searchIcon: {
    width: 36,
    right: 0,
    height: '100%',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: theme.transitions.create('right'),
    '&:hover': {
      cursor: 'pointer',
    },
  },
  searchIconOpened: {
    right: theme.spacing.unit * 1.25,
  },
  inputRoot: {
    color: 'inherit',
    width: '100%',
  },
  inputInput: {
    height: 36,
    padding: 0,
    paddingRight: 36 + theme.spacing.unit * 1.25,
    width: '100%',
  },
  messageContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  headerMenu: {
    marginTop: theme.spacing.unit * 7,
  },
  headerMenuList: {
    display: 'flex',
    flexDirection: 'column',
  },
  headerMenuItem: {
    '&:hover, &:focus': {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
  },
  headerMenuButton: {
    marginLeft: theme.spacing.unit * 2,
    padding: theme.spacing.unit / 2,
    '&:hover, &:focus': {
      backgroundColor: 'transparent',
    },
  },
  headerMenuButtonCollapse: {
    marginRight: theme.spacing.unit * 2,
  },
  headerIcon: {
    fontSize: 28,
    color: theme.palette.primary.main,
  },
  headerIconCollapse: {
    color: 'white',
  },
  profileMenu: {
    minWidth: 265,
  },
  profileMenuUser: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing.unit * 2,
  },
  profileMenuItem: {
    color: theme.palette.text.hint,
  },
  profileMenuIcon: {
    marginRight: theme.spacing.unit * 2,
    color: theme.palette.text.hint,
  },
  profileMenuLink: {
    fontSize: 16,
    textDecoration: 'none',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  profileMenulist: {
    display: 'flex',
    flexDirection: 'column',
    padding: '8px 20px',
  },
  messageNotification: {
    height: 'auto',
    display: 'flex',
    alignItems: 'center',
    '&:hover, &:focus': {
      backgroundColor: theme.palette.background.light,
    },
  },
  messageNotificationSide: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: "center",
    marginRight: theme.spacing.unit,
  },
  messageNotificationBodySide: {
    alignItems: 'flex-start',
    marginRight: 0,
  },
  sendMessageButton: {
    margin: theme.spacing.unit * 4,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    textTransform: 'none',
  },
  sendButtonIcon: {
    marginLeft: theme.spacing.unit * 2,
  },
  langButton: {
    minWidth: 32,
    color: 'rgba(255, 255, 255, 0.35)',
  },
  langButtonActive: {
    minWidth: 32,
    color: 'white',
  },
  languageHeader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
  languageButton: {
    marginLeft: '-15px',
    '&:hover, &:focus': {
      backgroundColor: 'transparent',
    },
  },
  dialogMenu: {
    backgroundColor: 'rgba(9,30,66,0.13)',
    border: 0,
    height: '1px',
    padding: 0,
    width: '92%',
    marginTop: '-5px',
  },
  iconBack: {
    position: 'fixed',
    cursor: 'pointer',
    transform: 'rotate(180deg)',
    zIndex: 1250,
    left: 230,
    top: 15,
  },
  iconOpen: {
    position: 'fixed',
    cursor: 'pointer',
    zIndex: 1250,
    left: 30,
    top: 15,
  },
  iconLogo: {
    display: 'flex',
    alignItems: 'baseline',
    fontSize: '18px',
    fontWeight: 500,
    marginTop: 5,
    // fontFamily: ''
  },
});
export const page = inject('screen', 'acknowledge', 'group', 'fcm')(observer(Header));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
